var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPhoneinline = function SvgPhoneinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.464 13.536c1.98 1.978 4.272 3.87 5.177 2.965 1.298-1.297 2.097-2.427 4.957-.13 2.859 2.301.663 3.832-.594 5.088-1.45 1.45-6.855.077-12.197-5.265C2.464 10.851 1.09 5.445 2.54 3.995 3.797 2.74 5.329.543 7.628 3.403c2.298 2.859 1.17 3.659-.129 4.956-.905.905.987 3.198 2.965 5.177Z",
    clipRule: "evenodd"
  })));
};

export default SvgPhoneinline;